export default __webpack_public_path__ + "static/media/eye-hide-icon.77b5c4eb.svg";